/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SetDefaultFacilityPhysicianRequestPhysicianId } from './SetDefaultFacilityPhysicianRequestPhysicianId';
import {
    SetDefaultFacilityPhysicianRequestPhysicianIdFromJSON,
    SetDefaultFacilityPhysicianRequestPhysicianIdFromJSONTyped,
    SetDefaultFacilityPhysicianRequestPhysicianIdToJSON,
    SetDefaultFacilityPhysicianRequestPhysicianIdToJSONTyped,
} from './SetDefaultFacilityPhysicianRequestPhysicianId';

/**
 * 
 * @export
 * @interface SetDefaultFacilityPhysicianRequest
 */
export interface SetDefaultFacilityPhysicianRequest {
    /**
     * 
     */
    physician_id: SetDefaultFacilityPhysicianRequestPhysicianId | null;
}

/**
 * Check if a given object implements the SetDefaultFacilityPhysicianRequest interface.
 */
export function instanceOfSetDefaultFacilityPhysicianRequest(value: object): value is SetDefaultFacilityPhysicianRequest {
    if (!('physician_id' in value) || value['physician_id'] === undefined) return false;
    return true;
}

export function SetDefaultFacilityPhysicianRequestFromJSON(json: any): SetDefaultFacilityPhysicianRequest {
    return SetDefaultFacilityPhysicianRequestFromJSONTyped(json, false);
}

export function SetDefaultFacilityPhysicianRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultFacilityPhysicianRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'physician_id': SetDefaultFacilityPhysicianRequestPhysicianIdFromJSON(json['physician_id']),
    };
}

export function SetDefaultFacilityPhysicianRequestToJSON(json: any): SetDefaultFacilityPhysicianRequest {
    return SetDefaultFacilityPhysicianRequestToJSONTyped(json, false);
}

export function SetDefaultFacilityPhysicianRequestToJSONTyped(value?: SetDefaultFacilityPhysicianRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'physician_id': SetDefaultFacilityPhysicianRequestPhysicianIdToJSON(value['physician_id']),
    };
}

